import React from 'react'
import moment from 'moment'

// components
import {
  CRow
} from '@coreui/react-pro'
import AppTextColumnDetails from '../general-details/AppTextColumnDetails'

const AppDetails = ({
  gameVoucherDetails,
}) => {
  return (
    <>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="3"
          title="Client code"
          subtitle={gameVoucherDetails?.voucher_code ? gameVoucherDetails?.voucher_code : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Expired date"
          subtitle={gameVoucherDetails?.expired_date ? moment(gameVoucherDetails?.expired_date).format('DD/MM/YYYY') : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Used?"
          subtitle={gameVoucherDetails?.is_used ? 'Yes' : 'No'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Game"
          subtitle={gameVoucherDetails?.game ? gameVoucherDetails?.game?.game_name : '-'}
        />
      </CRow>
    </>
  )
}

export default AppDetails
